export const DEVOTIONS_DATA = [
	// "Wypominki w Niedzielę przed Mszą św. o godz. 7.30",
	// "Modlitwa Różańcowa w niedzielę o godz.10.00",
	// "Zmiana tajemnic różańcowych - w I niedzielę miesiąca o 7.30",
	// "Nowenna do Matki Bożej Nieustającej Pomocy - w każdą środę o 18.00",
	// "Koronka do Bożego Miłosierdzia w piątek o 18.00, a w niedzielę o 14.50",
	// "Nabożeństwo w intencji powołań, nabożeństwo połączone z Adoracją Najświętszego Sakramentu i modlitwą różańcową - w I czwartek miesiąca o 17.30",
	// "Nabożeństwo misyjne - w I piątek miesiąca o 18.00",
	// "Nabożeństwo Fatimskie z procesją - 13-tego dnia miesiąca (maj - październik) o 19.00",
	// "Nabożeństwo Majowe o 17.30",
	// "Nabożeństwo czerwcowe ku czci Najświętszego Serca Pana Jezusa: w Oktawie Bożego Ciała, po Mszy św. wieczornej",
	// "Nieszpory Eucharystyczne w Oktawie Bożego Ciała o 18.00",
	// "Nabożeństwo różańcowe - październik o 17.30",
	// "Roraty w Adwencie o 18.00",
	// "Gorzkie Żale w Wielkim Poście - w niedzielę o 14.00",
	// "Droga Krzyżowa w Wielkim Poście - w piątki o 17.30, w niedzielę po Mszy św. o 10.30",
	'Wypominki w Niedzielę przed Mszą św. o godz. 7:00',
	'Modlitwa Różańcowa w niedzielę o godz.10:00',
	'Zmiana tajemnic różańcowych - w I sobotę miesiąca o 6:30',
	'Nowenna do Matki Bożej Nieustającej Pomocy - w każdą środę o 18:00',
	'Koronka do Bożego Miłosierdzia w piątek o 18:00, a w niedzielę o 6:50',
	'Nabożeństwo w intencji powołań, nabożeństwo połączone z Adoracją Najświętszego Sakramentu i modlitwą różańcową - w I czwartek miesiąca o 17:30',
	'Nabożeństwo misyjne - w I piątek miesiąca o 18:00',
	'Nabożeństwo Fatimskie z procesją - 13-tego dnia miesiąca (maj - październik) o 19:00',
	'Nabożeństwo Majowe o 17:30',
	'Nabożeństwo czerwcowe ku czci Najświętszego Serca Pana Jezusa: w Oktawie Bożego Ciała, po Mszy św. wieczornej',
	'Nieszpory Eucharystyczne w Oktawie Bożego Ciała o 18:00',
	'Nabożeństwo różańcowe - październik o 17:30',
	'Roraty w Adwencie o 6:30; 18:00',
	'Gorzkie Żale w Wielkim Poście - w niedzielę po Mszy św. o godz. 10:30',
	'Droga Krzyżowa w Wielkim Poście - w piątki o 17:30, w niedzielę po Mszy św. o 7:00.',
];
